import { Tabs as MuiTabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  DARK_MODE,
  isPuneJlr,
  NEW_PROCESSED_TAB,
  OPERATIONS,
  OPERATIONS_WITH_PROCESSED_TAB,
  PROCESSED_TAB,
  REDIRECT_URLS,
  TABS,
  UPCOMING_TAB,
  WORK_STREAM_TYPE,
} from '../../constants';
import { updateTab } from '../../redux/actionCreators/tab';
import { useEffect } from 'react';


const CssTabs = styled(MuiTabs)(() => ({
  height: 'auto',
  width: '100%',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    width: '100%',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    gap: '8px',
  },
}));

const CssTab = styled(Tab)(({ theme }) => ({
  fontFamily: "'JLR Emeric', sans-serif",
  fontWeight: 700,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#FFFFFF',
  border: 'none',
  transition: 'all 0.3s ease',
  marginRight: 0,

  flex: '1 1 0',
  minWidth: 0,
  maxWidth: 'none',

  // ✅ FIX: Default (unselected) state is dark blue
  background: '#0F107B',
  border: '1px solid #0F107B',

  // ✅ FIX: Selected state explicitly gets the green/gradient with !important
  // to override any MUI specificity conflicts
  '&.Mui-selected': {
    color: '#FFFFFF !important',
    boxShadow: '0px 0px 6px rgba(0,0,0,0.3)',
    background: `${
      theme.palette.mode === DARK_MODE
        ? '#1B681B'
        : 'linear-gradient(180deg, #6BA1E5 0%, #8385E4 100%)'
    } !important`,
  },

  // ✅ Unselected: explicit dark blue override
  '&:not(.Mui-selected)': {
    background: '#0F107B',
    color: '#FFFFFF',
    border: '1px solid #0F107B',
  },

  '&:first-of-type': {
    borderRadius: '50px 0 0 50px',
  },
  '&:last-of-type': {
    borderRadius: '0 50px 50px 0',
  },

  [theme.breakpoints.down('sm')]: {
    height: '45px',
    fontSize: '13px',
    borderRadius: '25px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    height: '50px',
    fontSize: '16px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '60px',
    fontSize: '20px',
  },
  [theme.breakpoints.up('xl')]: {
    height: '70px',
    fontSize: '24px',
  },
}));

const mapStateToProps = (state) => ({
  tabValue: state.tab.tabValue,
  allowedOperations: state.operations.allowedOperations,
  isMobileStation: state.user.isMobileStation,
  workStreamType: state.user.workStreamType,
});

const mapDispatchToProps = (dispatch) => ({
  updateTab: (tabValue) => dispatch(updateTab({ tabValue })),
});

export const Tabs = ({
  tabValue,
  allowedOperations,
  isMobileStation,
  updateTab,
  workStreamType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateTabs = (val) => {
    updateTab(val);
    if (val === 0) {
      navigate(
        allowedOperations.includes(OPERATIONS.MAJOR_REPAIR)
          ? REDIRECT_URLS[OPERATIONS.MAJOR_REPAIR]
          : '/',
      );
    }
    else if (val === 1) navigate('/upcoming-line-item');
    else if (val === 2) navigate('/processed-line-item');
    else if (val === 3) navigate('/processed');
  };

  useEffect(() => {
    if (location?.state?.fromModalConfirm) {
      navigateTabs(location?.state?.toTab);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location]);

  const hideUpcomingTab = () => {
    if (allowedOperations.includes(OPERATIONS.RECEIVE_SN)) return true;
    if (
      (allowedOperations.includes(OPERATIONS.DROP) ||
        allowedOperations.includes(OPERATIONS.SERIAL_NUMBER_GENERATE) ||
        allowedOperations.includes(OPERATIONS.PRINT_LABEL)) &&
      workStreamType === WORK_STREAM_TYPE.POOL
    )
      return true;
  };

  const hideOnScanVin = () => location.pathname === '/scan-vin';
  const isMajorRepairStation = allowedOperations.includes(OPERATIONS.MAJOR_REPAIR);

  return (
    <CssTabs value={tabValue} onChange={(_, value) => navigateTabs(value)}>
      {TABS.map(({ label, value }, index) => {
        const shouldHideUpcoming = hideUpcomingTab() && index === 1;
        const shouldHideOnScanVin = hideOnScanVin() && index === 2;
        const shouldHideMajorRepairTabs = isMajorRepairStation && (index === 1 || index === 2);

        if (shouldHideUpcoming || shouldHideOnScanVin || shouldHideMajorRepairTabs) return null;

        return (
          <CssTab
            key={value}
            label={label}
            value={index}
            disabled={
              (value === PROCESSED_TAB &&
                (isMobileStation ||
                  !allowedOperations.some((op) =>
                    OPERATIONS_WITH_PROCESSED_TAB.includes(op),
                  ))) ||
              (value === UPCOMING_TAB && isMobileStation) ||
              (value === NEW_PROCESSED_TAB && (isMobileStation && (!allowedOperations.includes(OPERATIONS.WCPA) && !isPuneJlr())))
            }
          />
        );
      })}
    </CssTabs>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);
